export function Export(organizationID: number): string {
	return `/v1/organizations/${organizationID}/payout-rows/export`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/payout-rows`;
}

